import { useContext, useState } from 'react';
import { LoggerContext } from "../context/logger.js";
/**
 * Returns a scoped Logger instance from the LoggerContext.
 * @param scope The logger's Scope name
 */
export const useLogger = scope => {
  const [logger] = useState(useContext(LoggerContext).withScope(scope));
  return logger;
};
//# sourceMappingURL=use-logger.js.map